module.exports = __webpack_public_path__ + "static/media/tutorial-banner-background.36d6ad5e.svg";